export interface Cookie {
  name: string,
  description: string,
  imageUrl: string,
  recipe: string,
}

export const Cookies: {[index: string]: Cookie} = {
  "Ascendant Apple Tart": {
    name: "Ascendant Apple Tart",
    description: "Deliver this exquisite delight to Queen Mara Sov in her chambers via the H.E.L.M.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/bd5edc0ef99acd2c6da6af788f59e33c.jpg",
    recipe: "Taken Butter, Sharp Flavor",
  },
  "Ascendant Oatmeal Raisin Cookies": {
    name: "Ascendant Oatmeal Raisin Cookies",
    description: "Deliver these delicious and nostalgic treats to Eris Morn on the Moon.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/a715b29f574c308f314634bd5d8a679f.jpg",
    recipe: "Chitin Powder, Finishing Touch",
  },
  "Bittersweet Biscotti": {
    name: "Bittersweet Biscotti",
    description: "Deliver this thoughtful treat to Crow in the Tangled Shore.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/510a4671d21565baa1c1b18f0f10f291.jpg",
    recipe: "Dark Ether Cane, Balanced Flavors",
  },
  "Blueberry Crumblers": {
    name: "Blueberry Crumblers",
    description: "Deliver this fresh recipe to Shaw in the Cosmodrome.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/8e8528e4fc533b77cc86f5c34e2ab6f3.jpg",
    recipe: "Ether Cane, Bullet Spray",
  },
  "Bright-Dusted Snowballs": {
    name: "Bright-Dusted Snowballs",
    description: "Deliver this indulgent confection to Tess in the Tower.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/7d27ad2bc1c7c02215e15f31c90c36d4.jpg",
    recipe: "Chitin Powder, Multifaceted Flavors",
  },
  "Candy Dead Ghosts": {
    name: "Candy Dead Ghosts",
    description: "Deliver these… things to the Spider in his safehouse on the Tangled Shore.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/a32bb837abbc51c04a13240c18f89b28.jpg",
    recipe: "Dark Ether Cane, Flash of Inspiration",
  },
  "Chocolate Ship Cookies": {
    name: "Chocolate Ship Cookies",
    description: "Deliver these finely tuned treats to Amanda Holliday in the Tower Hangar.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/9cc8a0c00a4421866016766e3e96bab6.jpg",
    recipe: "Cabal Oil, Null Taste",
  },
  "Classic Butter Cookies": {
    name: "Classic Butter Cookies",
    description: "Deliver this traditional treat to Eva in the Tower.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/3a2819131bdbb451a0ea2d36c3d8d4a4.jpg",
    recipe: "Taken Butter, Superb Texture",
  },
  "Dark Chocolate Motes": {
    name: "Dark Chocolate Motes",
    description: "Deliver these tempting morsels to the Drifter in the Annex.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/8a712271f7de627e4cf38eb392e8f6f9.jpg",
    recipe: "Taken Butter, Null Taste",
  },
  "Eliksni Birdseed": {
    name: "Eliksni Birdseed",
    description: "Deliver this high-end falcon food to Hawthorne's falcon Louis in the Tower Bazaar.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/98f8ff6b26899071de1b2b6c1fc819b0.jpg",
    recipe: "Ether Cane, Personal Touch",
  },
  "Etheric Coldsnaps": {
    name: "Etheric Coldsnaps",
    description: "Deliver this frozen delicacy to Variks on Europa.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/1944ff2bf6e26bec541914ecf2202640.jpg",
    recipe: "Chitin Powder, Electric Flavor",
  },
  "Gentleman's Shortbread": {
    name: "Gentleman's Shortbread",
    description: "Deliver this tasteful, tasty treat to Devrim Kay in Trostland in the European Dead Zone.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/26a3ef37eeef4a9b0293a7537af2dda1.jpg",
    recipe: "Ether Cane, Perfect Taste",
  },
  "Gjallardoodles": {
    name: "Gjallardoodles",
    description: "Deliver these explosively delicious treats to Commander Zavala in the Tower Courtyard.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/bb0069e9efc9698f366d63fdce0c6db7.jpg",
    recipe: "Ether Cane, Delicious Explosion",
  },
  "Ill-Fortune Cookies": {
    name: "Ill-Fortune Cookies",
    description: "Deliver these cursed yet delicious treats to Petra Venj wherever she can be found in the Reef.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/5c1d4e4af15100f1e5b2154dd50927a9.jpg",
    recipe: "Dark Ether Cane, Impossible Heat",
  },
  "Infinite Forest Cake": {
    name: "Infinite Forest Cake",
    description: "Deliver this conflicted confection to Failsafe in the Exodus Black on Nessus.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/a6f21c09d4741ec548ccde23afc3e943.jpg",
    recipe: "Vex Milk, Impossible Heat",
  },
  "Lavender Ribbon Cookies": {
    name: "Lavender Ribbon Cookies",
    description: "Deliver these sweet and triumphant treats to Saint-14 in the Tower Hangar.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/1cece8791684e7142627c7f2fa2da0dd.jpg",
    recipe: "Vex Milk, Personal Touch",
  },
  "Starwort Thins": {
    name: "Starwort Thins",
    description: "Deliver this timeless classic to the Exo Stranger on Europa.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/10e6e4678c665776a1bc18417de365f6.jpg",
    recipe: "Dark Ether Cane, Dark Frosting",
  },
  "Strange Cookies": {
    name: "Strange Cookies",
    description: "Deliver these treats, whose will is clearly not their own, to Xûr wherever the Nine have wished him to be.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/72cc666b334a39996f74b09a4850e773.jpg",
    recipe: "Taken Butter, Electric Flavor",
  },
  "Telemetry Tapioca": {
    name: "Telemetry Tapioca",
    description: "Deliver this dismantling delight to Banshee-44 in the Tower Courtyard.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/85bc7a8c18b58e6286fec57dc28ce077.jpg",
    recipe: "Vex Milk, Bullet Spray",
  },
  "Traveler Donut Holes": {
    name: "Traveler Donut Holes",
    description: "Deliver these unknowable alabaster spheres to Ikora Rey in the Tower Bazaar.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/b063620b4693d4a9df8f5aa62311e7d4.jpg",
    recipe: "Cabal Oil, Flash of Inspiration",
  },
  "Vanilla Blades": {
    name: "Vanilla Blades",
    description: "Deliver these deadly delights to Lord Shaxx in the Tower Courtyard.",
    imageUrl: "https://www.bungie.net/common/destiny2_content/icons/015e27d918af700828cdf30c2504e5ef.jpg",
    recipe: "Cabal Oil, Sharp Flavor",
  },
}